import { useContext } from "react";

import { useAuth } from "../../../context/Auth/AuthProvider";
import { FeatureToggles } from "../../../context/FeatureToggles/FeatureTogglesProvider";
import { getEnvironment } from "../../functions/functions";
import { IReleaseFeatures, ReleaseFeaturesNames } from "../types";

export const useReleaseFeatureToggle = () => {
  const {
    features: { releaseFeatures, usersFeatures, rolesFeatures }
  } = useContext<any>(FeatureToggles);

  const { user } = useAuth();

  const { isProductionEnv, isDevelopmentEnv, isStagingEnv } = getEnvironment();

  const isReleaseFeatureEnabled = (featureName: ReleaseFeaturesNames) => {
    return releaseFeatures({ isProductionEnv, isDevelopmentEnv }).some(
      (feature: IReleaseFeatures) => {
        if (feature.name === featureName) return feature.enabled;

        return false;
      }
    );
  };

  const isReleaseFeatureEnabledForUser = (
    featureName: ReleaseFeaturesNames,
    userEmail: string
  ) => {
    return releaseFeatures({
      isProductionEnv,
      isDevelopmentEnv,
      isStagingEnv
    }).some((feature: IReleaseFeatures) => {
      if (feature.name === featureName && feature.enabled) {
        if (usersFeatures[featureName].includes(userEmail)) {
          return true;
        }
      }

      return false;
    });
  };

  const isReleaseFeatureEnabledForRole = (
    featureName: ReleaseFeaturesNames,
    userRole: string
  ) => {
    return releaseFeatures({ isProductionEnv, isDevelopmentEnv }).some(
      (feature: IReleaseFeatures) => {
        if (feature.name === featureName && feature.enabled) {
          if (rolesFeatures[featureName]?.includes(userRole)) {
            return true;
          }
        }

        return false;
      }
    );
  };

  const isReleaseFeatureEnabledFromBE = (featureName: ReleaseFeaturesNames) => {
    return user ? user[featureName] : false;
  };

  const isFeatureSwitchEnabled = (
    featureName: ReleaseFeaturesNames,
    isFeatureOn: boolean
  ) => {
    return (
      isReleaseFeatureEnabledForUser(featureName, user?.email) && isFeatureOn
    );
  };

  return {
    isReleaseFeatureEnabled,
    isReleaseFeatureEnabledForUser,
    isReleaseFeatureEnabledForRole,
    isReleaseFeatureEnabledFromBE,
    isFeatureSwitchEnabled
  };
};
